var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "container py-4" },
    [
      !_vm.loading
        ? [
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex justify-content-end" }, [
                _c("p", [_vm._v("วันที่ " + _vm._s(_vm.documentDate) + " ")])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("p", { staticClass: "text-danger" }, [
                  _vm._v(
                    "     ตามที่ทางบริษัท บีนีท จำกัด ได้ปรับปรุงและพัฒนามาตรฐานในการให้บริการงานรีดผ้าเพื่อให้ทางคุณแม่บ้านได้รับความน่าเชื่อถือและความไว้วางใจจากคุณลูกค้าที่มาใข้บริการยิ่งขึ้น จึงได้มีข้อกำหนดที่ทางผู้ให้บริการในระบบจะต้องมี ”โต๊ะรองรีดผ้า” เป็นอุปกรณ์พื้นฐานเพิ่มเติม ในการเข้าให้บริการ โดยทางบริษัทฯ ได้มีการเพิ่มรายได้ในส่วนของคุณแม่บ้านที่ให้บริการงานรีดผ้าเพื่อรองรับการให้บริการที่ได้มาตรฐานดังกล่าวเรียบร้อยแล้ว รวมถึงอำนวยความสะดวกให้กับทางคุณแม่บ้าน โดยได้จัดจำหน่ายโต๊ะรองรีดผ้าผ่านทางระบบของบริษัท ในราคา 499 บาท (กรณีให้ทางบริษัทจัดส่งให้ คิดค่าบริการจัดส่งเพิ่มเติม 100 บาท) และการชำระเป็นการหักจากรายได้ของคุณแม่บ้าน ซึ่งมีรายละเอียดดังต่อไปนี้"
                  )
                ]),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                  1.1) ระบบจะตัดยอด 20% จากรายได้ที่ได้จากการเข้าให้บริการ ตามจำนวนงานทั้งหมดที่เข้าให้บริการแต่ละสัปดาห์ (นับตามรอบการจ่ายรายได้)\n              "
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                  1.2) การชำระค่าโต๊ะรองรีดผ้า จะต้องชำระจนครบ 499 บาท หรือ 599 บาท (ตามเงื่อนไขการจัดส่งสินค้า) ภายใน 60 วัน นับตั้งแต่วันที่มีการสั่งซื้อสินค้า\n              "
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                  1.3) คุณแม่บ้านโอนชำระเงินค่าโต๊ะรองรีดผ้าด้วยตนเอง เพื่อให้ครบตามจำนวนเงินที่ต้องชำระตามเงื่อนไขข้อ 1.1) และ ข้อ 1.2)\n              "
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                  1.4) หากระบบไม่สามารถทำการเรียกเก็บเงินค่าโต๊ะรองรีดผ้าจากคุณแม่บ้านตามข้อ 1.1) และ ข้อ 1.2) ระบบจะระงับการแสดงงานใหม่ในหน้าจอแอปพลิเคชั่นเป็นการชั่วคราว จนกว่าคุณแม่บ้านจะติดต่อมาดำเนินการชำระเงินค่าโต๊ะรองรีดผ้าด้วยตนเองตามข้อ 1.3)\n              "
                  )
                ]),
                _vm._v(" "),
                _vm._m(3),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                  2.1) หากผิดเงื่อนไข ข้อ 1 คุณแม่บ้านจะถูกระงับการแสดงงานใหม่ในหน้าจอแอปพลิเคชั่นเป็นการชั่วคราว\n              "
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                  ***หมายเหตุ: บริษัทฯ ขอสงวนสิทธิ์ ในการระงับการให้บริการคุณแม่บ้าน ในกรณีที่ทางคุณแม่บ้านไม่สามารถดำเเนินการตามขั้นตอนดังกล่าวได้ตามกำหนดภายในระยะเวลา\n              "
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                  ข้าพเจ้า นาง/นางสาว " +
                      _vm._s(_vm.professionalName) +
                      " หมายเลขผู้ให้บริการอิสระ " +
                      _vm._s(_vm.professionalId) +
                      " ได้อ่านรายละเอียดเงื่อนไข เอกสารแสดงความยินยอมให้หักรายได้ในการจัดซื้อโต๊ะรองรีดผ้า เป็นที่เข้าใจเรียบร้อยแล้ว และยิมยอมให้ทางบริษัท บีนีท จำกัด หักเงินรายได้ประจำสัปดาห์เพื่อชำระค่าโต๊ะรองรีดผ้าตามเงื่อนไขข้อ 1.\n              "
                  )
                ])
              ])
            ]
          ]
        : [
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _c("b-spinner", {
                  attrs: { variant: "primary", label: "Text Centered" }
                })
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("img", {
        staticClass: "rounded",
        attrs: { src: "/static/img/main-logo.svg", width: "140", alt: "..." }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { staticClass: "text-center mt-4" }, [
        _c("h3", [
          _vm._v("เอกสารแสดงความยินยอมให้หักรายได้ในการสั่งซื้อโต๊ะรองรีดผ้า")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [
        _vm._v(
          "1. ค่าโต๊ะรองรีดผ้า จำนวน 499 บาท (สี่ร้อยเก้าสิบเก้าบาทถ้วน) *กรณีให้ทางบริษัทจัดส่งให้ คิดค่าบริการจัดส่งเพิ่มเติม 100 บาท รวมเป็น 599 บาท ห้าร้อยเก้าสิบเก้าบาทถ้วน) โดยมีรายละเอียดดังนี้\n                  "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [
        _vm._v(
          "\n                      2. ความคุ้มครองและสิทธิประโยชน์\n                  "
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-449470ae", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-449470ae","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/IroningTableConsent.vue
// module id = 2082
// module chunks = 0